(function () {
   /**
    * Helper to extract ID from a URL hash
    */
   const getAnchor = (link) => link.href.includes('#') ? link.href.split('#')[1] : null;

   const fn_links = document.querySelectorAll('.fn_link');
   const back_to_content_links = document.querySelectorAll('.back_to_content_link');

   // 1. Handle Footnote Links (Going Down)
   fn_links.forEach(link => {
      link.addEventListener('click', function (e) {
         e.preventDefault();

         const anchorId = getAnchor(e.currentTarget);
         const sup_link_id = e.currentTarget.parentNode?.id;
         const targetLi = document.getElementById(anchorId);

         if (targetLi) {
            // Manage focus for accessibility
            targetLi.setAttribute('tabindex', '-1');
            targetLi.focus();

            // Dynamically update the back-link to point to the specific sup that called it
            const btc_link = targetLi.querySelector('a');
            if (btc_link && sup_link_id) {
               btc_link.href = `#${sup_link_id}`;
            }
         }
      });
   });

   // 2. Handle Back to Content Links (Going Up)
   back_to_content_links.forEach(link => {
      link.addEventListener('click', function (e) {
         e.preventDefault();

         const anchorId = getAnchor(e.currentTarget);
         const associated_sup = document.getElementById(anchorId);
         const sup_a = associated_sup?.querySelector('a');

         if (sup_a) {
            sup_a.focus();
         }
      });
   });

   console.log("Footnote accessibility initialized.");
})();